import {
  text,
  headline,
  field,
  button,
  spacer,
  image,
} from '@components/Widgets/_contentItems/all'
import themes from '@components/Widgets/Templates/Themes/all'
import { settings, styling } from '@components/Widgets/Templates/Base/_base'
import { maxWidth, position, trigger, type } from '@meta/widget/options'
import { tag, typeTag } from '@meta/widget/templates'

const info = {
  name: 'Stay in Tune Announcement',
  templateID: '7',
  description: 'Keep your audience informed with the "Stay In Tune Announcement" widget. With a wide banner image and bold buttons, this template ensures your announcements and calls to action are prominent and easily noticeable.',
  tags: [typeTag.FLYOUT, tag.LEAD_GENERATION, tag.ANNOUNCEMENT],
}

const json = {
  id: 8687811,
  templateID: info.templateID,
  type: type.IMAGE_COLUMN,
  name: info.name,
  theme: themes.MONOCHROME.theme,
  active: true,
  settings: (() => {
    const customSettings = { ...settings }
    customSettings.trigger = trigger.RIBBON
    customSettings.position = position.CENTER
    customSettings.animation = 'slide'
    // customSettings.closeButton = false
    customSettings.ribbonColor = 'rgba(254, 254, 254, 1)'
    customSettings.closeButtonColor = 'rgb(255, 244, 244)'
    customSettings.sideImage = (() => {
      const customImage = JSON.parse(JSON.stringify(image))
      customImage.content.url = 'https://assets.onvocado.com/uploads/6ca58496-e2af-11ee-aa57-e60824134996.png'
      return customImage
    })()

    return customSettings
  })(),
  styling: (() => {
    const customStyling = { ...styling } // Ensure we're working with a copy of the styling
    customStyling.maxWidth = maxWidth.EXTRA_LARGE
    customStyling.backgroundImage = ''
    return customStyling
  })(),
  steps: [
    {
      id: '9ei8h34',
      contentItems: [
        // headline
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Stay tune!'
          Object.assign(customHeadline.styling, {
            color: 'rgba(24, 23, 26, 1)',
            fontSize: '28px',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        // text
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = 'Don\'t miss our biggest sale yet. Enter your email to stay informed.'
          Object.assign(customText.styling, {
            color: 'rgba(24, 23, 26, 1)',
            fontSize: '16px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        // field
        (() => {
          const customField = JSON.parse(JSON.stringify(field))
          customField.content.placeholder = 'Your Email Address'
          Object.assign(customField.styling, {
            color: 'rgba(65, 65, 65, 1)',
            fontSize: '14px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgba(81, 81, 81, 1)',
            borderWidth: '2px',
            borderRadius: '8px',
            backgroundColor: 'rgba(254, 254, 254, 1)',
          })
          customField.settings.type = 'email'
          customField.settings.label = 'Email address'
          customField.settings.required = true
          return customField
        })(),
        // button
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'Keep me informed'
          Object.assign(customButton.styling, {
            color: 'rgba(254, 254, 254, 1)',
            fontSize: '16px',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgba(3, 3, 3, 1)',
            borderWidth: '2px',
            borderRadius: '4px',
            justifyContent: 'center',
            backgroundColor: 'rgba(3, 3, 3, 1)',
          })
          customButton.settings.action = 'next'
          customButton.settings.backBtn = false
          return customButton
        })(),
      ],
    },
    {
      id: '9el9p3p',
      contentItems: [
        // headline
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Thank You for Signing Up! 🎉'
          Object.assign(customHeadline.styling, {
            color: 'rgb(24, 23, 26)',
            fontSize: '28px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        // text
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = ' Stay tuned for more exciting updates!'
          Object.assign(customText.styling, {
            color: 'rgb(24,23,26)',
            fontSize: '16px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        // spacer
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '20px' })
          return customSpacer
        })(),
        // button
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'Continue Shopping'
          Object.assign(customButton.styling, {
            color: 'rgba(254, 254, 254, 1)',
            fontSize: '16px',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgba(3, 3, 3, 1)',
            borderWidth: '2px',
            borderRadius: '4px',
            justifyContent: 'center',
            backgroundColor: 'rgba(3, 3, 3, 1)',
          })
          customButton.settings.action = 'close'
          customButton.settings.backBtn = false
          return customButton
        })(),
      ],
    },
  ],
}

export { json, info }